import { GEOLOCATION_SETTINGS_IMAGES } from 'config/images';
import { AppLocale, getAppLocaleValue, getTrans } from 'modules/i18n';
import { GuideImages } from './types';

export const altPrefix = 'Geolocation settings';

// Video URLs for geolocation setup guides
export const iosBrowserVideoUrl =
  'https://s3.eu-central-1.amazonaws.com/cdn-ops.zenjob.de/Zenjob/PRO_geofence_ios_enable_location_default_browser.MP4';
export const iosSystemVideoUrl =
  'https://s3.eu-central-1.amazonaws.com/cdn-ops.zenjob.de/Zenjob/PRO_geofence_ios_enable_location_system.mp4';
export const androidBrowserVideoUrl =
  'https://s3.eu-central-1.amazonaws.com/cdn-ops.zenjob.de/Zenjob/PRO_geofence_android_enable_location_default_browser.mp4';
export const androidSystemVideoUrl =
  'https://s3.eu-central-1.amazonaws.com/cdn-ops.zenjob.de/Zenjob/PRO_geofence_android_enable_location_system.mp4';

export const androidDeviceImages: GuideImages = {
  [getAppLocaleValue[AppLocale.en_US]]: [
    GEOLOCATION_SETTINGS_IMAGES.android1.en,
    GEOLOCATION_SETTINGS_IMAGES.android2.en,
    GEOLOCATION_SETTINGS_IMAGES.android3.en,
    GEOLOCATION_SETTINGS_IMAGES.android4.en,
    GEOLOCATION_SETTINGS_IMAGES.android5.en
  ],
  [getAppLocaleValue[AppLocale.de_DE]]: [
    GEOLOCATION_SETTINGS_IMAGES.android1.de,
    GEOLOCATION_SETTINGS_IMAGES.android2.de,
    GEOLOCATION_SETTINGS_IMAGES.android3.de,
    GEOLOCATION_SETTINGS_IMAGES.android4.de,
    GEOLOCATION_SETTINGS_IMAGES.android5.de
  ]
};
export const androidBrowserImages: GuideImages = {
  [getAppLocaleValue[AppLocale.en_US]]: [
    GEOLOCATION_SETTINGS_IMAGES.android6.en,
    GEOLOCATION_SETTINGS_IMAGES.android7.en,
    GEOLOCATION_SETTINGS_IMAGES.android8.en,
    GEOLOCATION_SETTINGS_IMAGES.android9.en,
    GEOLOCATION_SETTINGS_IMAGES.android10.en,
    GEOLOCATION_SETTINGS_IMAGES.android11.en,
    GEOLOCATION_SETTINGS_IMAGES.android12.en,
    GEOLOCATION_SETTINGS_IMAGES.android13.en,
    GEOLOCATION_SETTINGS_IMAGES.android14.en
  ],
  [getAppLocaleValue[AppLocale.de_DE]]: [
    GEOLOCATION_SETTINGS_IMAGES.android6.de,
    GEOLOCATION_SETTINGS_IMAGES.android7.de,
    GEOLOCATION_SETTINGS_IMAGES.android8.de,
    GEOLOCATION_SETTINGS_IMAGES.android9.de,
    GEOLOCATION_SETTINGS_IMAGES.android10.de,
    GEOLOCATION_SETTINGS_IMAGES.android11.de,
    GEOLOCATION_SETTINGS_IMAGES.android12.de,
    GEOLOCATION_SETTINGS_IMAGES.android13.de,
    GEOLOCATION_SETTINGS_IMAGES.android14.de
  ]
};

export const iosDeviceImages: GuideImages = {
  [getAppLocaleValue[AppLocale.en_US]]: [
    GEOLOCATION_SETTINGS_IMAGES.ios1.en,
    GEOLOCATION_SETTINGS_IMAGES.ios2.en,
    GEOLOCATION_SETTINGS_IMAGES.ios3.en,
    GEOLOCATION_SETTINGS_IMAGES.ios4.en,
    GEOLOCATION_SETTINGS_IMAGES.ios5.en
  ],
  [getAppLocaleValue[AppLocale.de_DE]]: [
    GEOLOCATION_SETTINGS_IMAGES.ios1.de,
    GEOLOCATION_SETTINGS_IMAGES.ios2.de,
    GEOLOCATION_SETTINGS_IMAGES.ios3.de,
    GEOLOCATION_SETTINGS_IMAGES.ios4.de,
    GEOLOCATION_SETTINGS_IMAGES.ios5.de
  ]
};

export const iosBrowserImages: GuideImages = {
  [getAppLocaleValue[AppLocale.en_US]]: [
    GEOLOCATION_SETTINGS_IMAGES.ios6.en,
    GEOLOCATION_SETTINGS_IMAGES.ios7.en,
    GEOLOCATION_SETTINGS_IMAGES.ios8.en,
    GEOLOCATION_SETTINGS_IMAGES.ios9.en,
    GEOLOCATION_SETTINGS_IMAGES.ios10.en,
    GEOLOCATION_SETTINGS_IMAGES.ios11.en
  ],
  [getAppLocaleValue[AppLocale.de_DE]]: [
    GEOLOCATION_SETTINGS_IMAGES.ios6.de,
    GEOLOCATION_SETTINGS_IMAGES.ios7.de,
    GEOLOCATION_SETTINGS_IMAGES.ios8.de,
    GEOLOCATION_SETTINGS_IMAGES.ios9.de,
    GEOLOCATION_SETTINGS_IMAGES.ios10.de,
    GEOLOCATION_SETTINGS_IMAGES.ios11.de
  ]
};

export const desktopImages: GuideImages = {
  [getAppLocaleValue[AppLocale.en_US]]: [
    GEOLOCATION_SETTINGS_IMAGES.desktop1.en,
    GEOLOCATION_SETTINGS_IMAGES.desktop2.en,
    GEOLOCATION_SETTINGS_IMAGES.desktop3.en,
    GEOLOCATION_SETTINGS_IMAGES.desktop4.en,
    GEOLOCATION_SETTINGS_IMAGES.desktop5.en,
    GEOLOCATION_SETTINGS_IMAGES.desktop6.en
  ],
  [getAppLocaleValue[AppLocale.de_DE]]: [
    GEOLOCATION_SETTINGS_IMAGES.desktop1.de,
    GEOLOCATION_SETTINGS_IMAGES.desktop2.de,
    GEOLOCATION_SETTINGS_IMAGES.desktop3.de,
    GEOLOCATION_SETTINGS_IMAGES.desktop4.de,
    GEOLOCATION_SETTINGS_IMAGES.desktop5.de,
    GEOLOCATION_SETTINGS_IMAGES.desktop6.de
  ]
};

export const getAndroidDeviceInstructions = () => [
  [
    getTrans('geolocationSettingsPage.instructions.android1.part1'),
    getTrans('geolocationSettingsPage.instructions.android1.part2'),
    getTrans('geolocationSettingsPage.instructions.android1.part3')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.android2.part1'),
    getTrans('geolocationSettingsPage.instructions.android2.part2'),
    getTrans('geolocationSettingsPage.instructions.android2.part3'),
    getTrans('geolocationSettingsPage.instructions.android2.part4'),
    getTrans('geolocationSettingsPage.instructions.android2.part5')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.android3.part1'),
    getTrans('geolocationSettingsPage.instructions.android3.part2'),
    getTrans('geolocationSettingsPage.instructions.android3.part3'),
    getTrans('geolocationSettingsPage.instructions.android3.part4')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.android4.part1'),
    getTrans('geolocationSettingsPage.instructions.android4.part2'),
    getTrans('geolocationSettingsPage.instructions.android4.part3')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.android5.part1'),
    getTrans('geolocationSettingsPage.instructions.android5.part2')
  ]
];

export const getAndroidBrowserInstructions = () => [
  [
    getTrans('geolocationSettingsPage.instructions.browser.android1.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.android1.part2')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.browser.android2.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.android2.part2')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.browser.android3.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.android3.part2'),
    getTrans('geolocationSettingsPage.instructions.browser.android3.part3')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.browser.android4.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.android4.part2'),
    getTrans('geolocationSettingsPage.instructions.browser.android4.part3'),
    getTrans('geolocationSettingsPage.instructions.browser.android4.part4')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.browser.android5.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.android5.part2')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.browser.android6.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.android6.part2')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.browser.android7.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.android7.part2'),
    getTrans('geolocationSettingsPage.instructions.browser.android7.part3')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.browser.android8.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.android8.part2')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.browser.android9.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.android9.part2')
  ]
];

export const getiOSBrowserInstructions = () => [
  [
    getTrans('geolocationSettingsPage.instructions.browser.ios1.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.ios1.part2')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.browser.ios2.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.ios2.part2'),
    getTrans('geolocationSettingsPage.instructions.browser.ios2.part3')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.browser.ios3.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.ios3.part2'),
    getTrans('geolocationSettingsPage.instructions.browser.ios3.part3')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.browser.ios4.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.ios4.part2'),
    getTrans('geolocationSettingsPage.instructions.browser.ios4.part3')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.browser.ios5.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.ios5.part2'),
    getTrans('geolocationSettingsPage.instructions.browser.ios5.part3')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.browser.ios6.part1'),
    getTrans('geolocationSettingsPage.instructions.browser.ios6.part2')
  ]
];

export const getiOSDeviceInstructions = () => [
  [
    getTrans('geolocationSettingsPage.instructions.ios1.part1'),
    getTrans('geolocationSettingsPage.instructions.ios1.part2'),
    getTrans('geolocationSettingsPage.instructions.ios1.part3')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.ios2.part1'),
    getTrans('geolocationSettingsPage.instructions.ios2.part2'),
    getTrans('geolocationSettingsPage.instructions.ios2.part3'),
    getTrans('geolocationSettingsPage.instructions.ios2.part4'),
    getTrans('geolocationSettingsPage.instructions.ios2.part5')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.ios3.part1'),
    getTrans('geolocationSettingsPage.instructions.ios3.part2'),
    getTrans('geolocationSettingsPage.instructions.ios3.part3')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.ios4.part1'),
    getTrans('geolocationSettingsPage.instructions.ios4.part2')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.ios5.part1'),
    getTrans('geolocationSettingsPage.instructions.ios5.part2'),
    getTrans('geolocationSettingsPage.instructions.ios5.part3')
  ]
];

export const getDesktopInstructions = () => [
  [
    getTrans('geolocationSettingsPage.instructions.desktop1.part1'),
    getTrans('geolocationSettingsPage.instructions.desktop1.part2'),
    getTrans('geolocationSettingsPage.instructions.desktop1.part3')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.desktop2.part1'),
    getTrans('geolocationSettingsPage.instructions.desktop2.part2'),
    getTrans('geolocationSettingsPage.instructions.desktop2.part3')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.desktop3.part1'),
    getTrans('geolocationSettingsPage.instructions.desktop3.part2')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.desktop4.part1'),
    getTrans('geolocationSettingsPage.instructions.desktop4.part2')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.desktop5.part1'),
    getTrans('geolocationSettingsPage.instructions.desktop5.part2'),
    getTrans('geolocationSettingsPage.instructions.desktop5.part3')
  ],
  [
    getTrans('geolocationSettingsPage.instructions.desktop6.part1'),
    getTrans('geolocationSettingsPage.instructions.desktop6.part2')
  ]
];
